<template>
  <v-navigation-drawer
      class="main-bg"
      v-model="show_aside"
      app
      dark
      clipped
      :src="getBackgroundImage()"
      overlay-color="red"
      @input="setShow"
  >
    <v-list
        nav
        dense
    >
      <v-subheader>Меню</v-subheader>
      <v-list-item-group
          active-class="gray--text"
      >
        <v-list-item to="/dashboard/catalog">
          <v-icon class="mr-2">list</v-icon>
          <v-list-item-title>Каталог</v-list-item-title>
        </v-list-item>

        <v-list-item to="/dashboard/products">
          <v-icon class="mr-2">category</v-icon>
          <v-list-item-title>{{ $t('products.label') }}</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="hasPermission('etalon.special.manage')" to="/dashboard/specials">
          <v-icon class="mr-2">folder_special</v-icon>
          <v-list-item-title>{{ $t('specials.label') }}</v-list-item-title>
        </v-list-item>
        <v-list-group
            active-class="white--text"
            v-if="hasPermission('etalon.special_template.manage') || hasPermission('etalon.commercial_proposal.manage')"
            no-action
        >
          <template v-slot:activator>
            <v-icon class="mr-2">mdi-octagram-outline</v-icon>
            <v-list-item-title>{{ $t('templates.label') }}</v-list-item-title>
          </template>
          <v-list-item
              active-class="white--text"
              v-if="hasPermission('etalon.special_template.manage')"
              to="/dashboard/special-templates"
          >
            <v-icon class="mr-2">folder_special</v-icon>
            <v-list-item-title>{{ $t('special_templates.label') }}</v-list-item-title>
          </v-list-item>
          <v-list-item
              active-class="white--text"
              v-if="hasPermission('etalon.commercial_proposal.manage')"
              to="/dashboard/commercial-proposals"
          >
            <v-icon class="mr-2">mdi-clipboard-file-outline</v-icon>
            <v-list-item-title>{{ $t('commercial_proposals.label') }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-item v-if="hasPermission('etalon.client.view')" to="/dashboard/clients">
          <v-icon class="mr-2">person</v-icon>
          <v-list-item-title>{{ $t('clients.label') }}</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="hasPermission('etalon.order.view')" to="/dashboard/orders/etalon/reserves">
          <v-icon class="mr-2">wysiwyg</v-icon>
          <v-list-item-title>{{ $t('orders.label') }}</v-list-item-title>
        </v-list-item>
        <v-list-group
            active-class="white--text"
            v-if="hasPermission('cylinder.order.view')"
            no-action
        >
          <template v-slot:activator>
            <v-icon class="mr-2">mdi-hat-fedora</v-icon>
            <v-list-item-title>{{ $t('inet-orders.label') }}</v-list-item-title>
          </template>
          <v-list-item
              v-if="hasPermission('cylinder.order.view')"
              active-class="white--text"
              :to="{ name: 'CylinderOrdersList' }"
          >
            <v-list-item-title>{{ $t('inet-orders.orders') }}</v-list-item-title>
          </v-list-item>
          <v-list-item
              v-if="hasPermission('cylinder.specials.manage')"
              active-class="white--text"
              :to="{name: 'CylinderSpecialsList'}">
            <v-list-item-title>{{ $t('cylinder.specials.label') }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-group
            active-class="white--text"
            no-action
            v-if="hasPermission('drop.order.view')
            || hasPermission('drop.client.view')
            || hasPermission('drop.client.withdraw')
            || hasPermission('drop.notification.manage')"
        >
          <template v-slot:activator>
            <v-icon class="mr-2">wysiwyg</v-icon>
            <v-list-item-title>Drop IT</v-list-item-title>
          </template>
          <v-list-item v-if="hasPermission('drop.order.view')" active-class="white--text" to="/dashboard/drop-orders">
            <v-list-item-title>Заказы</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="hasPermission('drop.client.view')" active-class="white--text" to="/dashboard/drop-users">
            <v-list-item-title>Пользователи</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="hasPermission('drop.client.withdraw.view')" active-class="white--text"
                       to="/dashboard/drop-withdraws">
            <v-list-item-title>Запросы на вывод</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="hasPermission('drop.notification.manage')" active-class="white--text"
                       to="/dashboard/drop-messages">
            <v-list-item-title>{{ $t('drop_messages.label') }}</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="hasPermission('drop.client.balance_correction')" active-class="white--text"
                       to="/dashboard/drop-payment-documents">
            <v-list-item-title>{{ $t('drop_payment_documents.label') }}</v-list-item-title>
          </v-list-item>
          <v-list-item
              v-if="hasPermission('drop.special.manage')"
              active-class="white--text"
              :to="{name: 'DropSpecialList'}">
            <v-list-item-title>{{ $t('drop.specials.label') }}</v-list-item-title>
          </v-list-item>
          <v-list-item
              v-if="hasPermission('drop.referral.manage')"
              active-class="white--text"
              :to="{name: 'DropReferralList'}">
            <v-list-item-title>{{ $t('drop.referrals.label') }}</v-list-item-title>
          </v-list-item>
          <v-list-item
              v-if="hasPermission('drop.referral.manage')"
              active-class="white--text"
              :to="{name: 'DropPromoCodeList'}">
            <v-list-item-title>{{ $t('drop.promo_codes.label') }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-group
            no-action
        >
          <template v-slot:activator>
            <v-icon class="mr-2">query_stats</v-icon>
            <v-list-item-title>Статистика</v-list-item-title>
          </template>
          <v-list-item to="/dashboard/statistics/products">
            <v-list-item-title>Товары</v-list-item-title>
          </v-list-item>
          <v-list-item to="/dashboard/statistics/orders">
            <v-list-item-title>Заказы</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'MainMenuAsideComponent',
  props: ['is_show'],
  data: () => ({
    show_aside: false
  }),
  computed: {
    ...mapGetters('auth', ['hasPermission']),
    ...mapState('auth', ['user'])
  },
  watch: {
    is_show: {
      immediate: true,
      handler (v) {
        this.show_aside = v
        this.$emit('show-main-menu', v)
      }
    }
  },
  methods: {
    setShow (v) {
      this.$emit('show-main-menu', v)
    },
    getBackgroundImage () {
      const backgroundImages = {
        winter1: 'https://i.pinimg.com/736x/df/81/75/df817542795c72f9f77918d1a9ecd25a.jpg',
        winter2: 'https://i.pinimg.com/736x/07/3a/ca/073aca0d9edd7b9252ed1beb318a2a31.jpg',
        winter3: 'https://i.pinimg.com/736x/1e/55/1b/1e551b05ddc4941b35e82b9b2128339a.jpg',
        spring1: 'https://i.pinimg.com/736x/38/bf/01/38bf018d5d99f44c8af0c15f67800007.jpg',
        spring2: 'https://i.pinimg.com/736x/50/7b/e3/507be349737e708458a4286be709ef09.jpg',
        spring3: 'https://i.pinimg.com/736x/3c/fe/74/3cfe74beec1850d1c4454ac0a99b65b4.jpg',
        summer1: 'https://i.pinimg.com/736x/55/6f/3e/556f3e8b82763947b994421b50c3c02f.jpg',
        summer2: 'https://i.pinimg.com/736x/cf/67/5f/cf675ffe7457d0ab44776d1b3383e7d7.jpg',
        summer3: 'https://i.pinimg.com/736x/33/47/cc/3347cc018a9e20d08ce14e4757e60c68.jpg',
        fall1: 'https://i.pinimg.com/736x/96/d3/38/96d338a718637c750738cbd4dcb06ead.jpg',
        fall2: 'https://i.pinimg.com/736x/49/55/2b/49552bf9d2525db0c3e6f9c6440917ff.jpg',
        fall3: 'https://i.pinimg.com/1200x/e7/f5/a6/e7f5a6c1009a2bae3a604ebf5155d02c.jpg',
        new_year: 'https://i.pinimg.com/736x/b4/21/d3/b421d34e0bc6a11bd35f4182be67fbb1.jpg',
        merry: 'https://i.pinimg.com/736x/2c/48/96/2c48966f444044c45412fc4d5c438761.jpg'
      }

      const today = new Date()
      const month = today.getMonth() + 1 // Январь = 0
      const day = today.getDate()

      // Проверка периодов
      // Рождество
      if ((month === 12 && day >= 5) && (month === 12 && day <= 26)) {
        return backgroundImages.merry // Рождество
      }

      if ((month === 12 && day >= 26) || (month === 1 && day <= 15)) {
        return backgroundImages.new_year // Новый год
      }

      switch (month) {
        case 1:
          return backgroundImages.winter2
        case 2:
          return backgroundImages.winter3
        case 3:
          return backgroundImages.spring1
        case 4:
          return backgroundImages.spring2
        case 5:
          return backgroundImages.spring3
        case 6:
          return backgroundImages.summer1
        case 7:
          return backgroundImages.summer2
        case 8:
          return backgroundImages.summer3
        case 9:
          return backgroundImages.fall1
        case 10:
          return backgroundImages.fall2
        case 11:
          return backgroundImages.fall3
        case 12:
          return backgroundImages.winter1
      }

      return backgroundImages.winter1
    }
  }
}
</script>

<style lang="scss">
.v-list-group__items > .v-list-item {
  padding-left: 48px!important;
}
</style>
